// Import entities.
// TODO.

// Import business logic.
import Items from './model/logic/Items.js';

/**
 * UgcWall model entities.
 *
 * @memberof module:UgcWall.Model
 * @namespace
 */
const Entity = {
};
export { Entity };

/**
 * UgcWall model business logic.
 *
 * @memberof module:UgcWall.Model
 * @namespace
 */
const Logic = {
	Items
};
export { Logic };

/**
 * UgcWall model.
 *
 * @author Tim Loram
 *
 * @memberof module:UgcWall
 * @namespace
 *
 * @type {Object}
 * @property {Object} Entity All model Entities
 * @property {Object} Logic All model Business Logic
 */
const Model = {
	Entity,
	Logic
};

export default Model;